// TODO: fix
export const accessTokenProvider = () =>
  Promise.resolve(localStorage.getItem("accessToken"));
